import { ButtonColors, ButtonSizes, PrimaryButton } from 'src/shared/design-system//Buttons';
import { TextArea } from 'src/shared/design-system/Input';
import { MediaUpload } from 'src/shared/design-system/PhotoUpload';
import { PromoCode, Upload } from 'src/shared/design-system/ShefSocial/Icons';
import { Clickable } from 'src/shared/design-system/Utilities';
import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled, { css } from 'styled-components';
import { Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';
import { COMPOSER_TEXT } from '../consts';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.SINGLE};
  justify-content: center;
`;

export const InputContainer = styled.div`
  width: 100%;
`;

export const Input = styled(TextArea).attrs(() => ({
  autoHeight: true,
  fluid: true,
  rows: 1,
}))`
  flex: 1 1 100%;
  min-height: ${Spacing.TRIPLE};
  resize: none;
  box-sizing: border-box;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin: 0 0 0 -${Spacing.HALF};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 100%;
  gap: ${Spacing.HALF};
  position: relative;

  &:last-child {
    justify-content: flex-end;
  }
`;

export const Image = styled.img`
  max-width: 100%;
`;

export const ActionButton = styled(Clickable)<{ isActive?: boolean; isSelected?: boolean }>`
  background: none;
  border-radius: ${Spacing.DOUBLE};
  color: ${Colors.GRAY_DARK_10};
  cursor: pointer;
  padding: ${Spacing.QUARTER} ${Spacing.HALF};
  transition: background ${Transition.Time.BASE}, color ${Transition.Time.BASE};

  ${Font.bySize(Font.Size.XS, Font.Weight.SEMI_BOLD)}
  &:hover {
    color: ${Colors.BELL_PEPPER_DARK_10};
  }

  ${ifProp(
    'isActive',
    css`
      background: ${Colors.BELL_PEPPER_LITE_30};
      color: ${Colors.BELL_PEPPER_DARK_30};
    `
  )}

  ${ifProp(
    'isSelected',
    css`
      color: ${Colors.RADISH};
    `
  )}
`;

export const ActionButtonContainer = styled.div`
  gap: ${Spacing.HALF};
  white-space: nowrap;
  ${Mixins.Flex.center()}
`;

export const UploadButton = styled(ActionButton).attrs(({ isSelected }: { isSelected?: boolean }) => ({
  children: (
    <ActionButtonContainer>
      <Upload />
      {isSelected ? COMPOSER_TEXT.BUTTON.CHANGE : COMPOSER_TEXT.BUTTON.UPLOAD}
    </ActionButtonContainer>
  ),
}))``;

export const PromoCodeButton = styled(ActionButton).attrs(({ hasPromo }: { hasPromo: boolean }) => ({
  children: (
    <ActionButtonContainer>
      <PromoCode />
      {hasPromo ? COMPOSER_TEXT.BUTTON.HAS_PROMO_CODE : COMPOSER_TEXT.BUTTON.PROMO_CODE}
    </ActionButtonContainer>
  ),
}))<{ hasPromo?: boolean }>``;

export const PostButton = styled(PrimaryButton).attrs(() => ({
  children: COMPOSER_TEXT.BUTTON.POST,
  color: ButtonColors.RED,
  size: ButtonSizes.S,
}))`
  font-weight: ${Font.Weight.SEMI_BOLD};

  &[disabled] {
    background: ${Colors.GRAY_LITE_10};
    color: ${Colors.GRAY_DARK_10};
  }
`;

export const PromoCodeText = styled.div`
  background: ${Colors.BELL_PEPPER_LITE_30};
  cursor: default;
  color: ${Colors.BELL_PEPPER_DARK_20};
  padding: ${Spacing.SINGLE};
  ${Font.bySize(Font.Size.XS)}
`;

export const Uploader = styled(MediaUpload)`
  display: contents;
  justify-content: center;
`;
